<template>
  <div>
    <div v-if="!googleFailed">
      <div class="row">
        <div id="handoverMap" class="col-lg-12 col-7"></div>

        <div class="d-none d-lg-block alert alert-info mt-3 col-lg-12">
          <div class="row">
            <div class="col-1 d-flex justify-content-center align-items-center">
              <i class="fal fa-exclamation-circle fa-2x"></i>
            </div>
            <div class="col-11">
              <span v-html="navigation.message"></span>
            </div>
          </div>
        </div>

        <div class="col-5 d-block d-lg-none d-flex align-items-stretch">
          <div class="alert alert-info mb-0">
            <div class="row">
              <div class="col-12 d-flex justify-content-center text-center py-1">
                <i class="fal fa-exclamation-circle fa-2x"></i>
              </div>
              <div class="col-12 text-center py-3 d-flex align-items-center">
                <span v-html="navigation.message"></span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div v-else>
      <div class="d-none d-lg-block alert alert-info mt-3 col-lg-12">
        <div class="row">
          <div class="col-1 d-flex justify-content-center align-items-center">
            <i class="fal fa-exclamation-circle fa-2x"></i>
          </div>
          <div class="col-11">
            Leider ist ein Fehler in Verbindung mit Google Maps aufgetreten, sodass wir die Karte nicht anzeigen können. <br>
            <span id="allowFunctionalCookies" class="btn btn-outline-secondary mt-3" @click="openGoogleMaps">Zu Google Maps</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import PNotify from 'pnotify/dist/es/PNotify';

PNotify.defaults.styling = 'bootstrap4';
PNotify.defaults.icons = 'fontawesome5';
export default {
  name: "MapRoute",
  props: {
    origin: {
      type: Object,
      required: true
    },
    destination: {
        type: Object,
      required: true
    },
    costs: {
      type: String,
      required: false
    },
    stepRegisterUrl: {
      type: String,
      required: false
    },
    country: {
      type: String,
      required: false,
      default: "de"
    }
  },
  watch: {
    origin: {
      handler (newValue, oldValue) {
        if (this.isDifferentAddress (newValue, oldValue)) {
          axios.get ("https://maps.googleapis.com/maps/api/geocode/json", {
            params: {
              address: this.origin,
              key: this.$googleMapsApi,
              country: this.country
            }
          }).then (result => {
            this.setStart (result.data.results[0]);
            this.initMap ();
            this.calcRoute ();
            PNotify.success ("Route neu berechnet!");
          }).catch (error => {
            PNotify.error ("Es kam zu einem Fehler bei der Neuberechnung der Route...");
          });
        } else {
        }
      },
      deep: false
    }
  },
  data () {
    return {
      api: {
        directionsUrl: 'https://maps.googleapis.com/maps/api/directions/json?origin=%origin%&destination=%destination%&key=%key%'
      },
      map: {
        map: {},
        options: {},
        directionsService: {},
        directionsDisplay: {},
        loaded: false,
      },
      start: {
        loaded: false,
        location: {}
      },
      navigation: {
        show: false,
        distance: 0,
        duration: 0,
        message: ""
      },
      googleFailed: false
    }
  },
  computed: {
    getDirectionsApiUrl () {
      let url = this.api.directionsUrl;
      url = url.replace ("%key%", this.$googleMapsApi);

      let origin = this.origin.street + " " + this.origin.house_number + " " + this.origin.postal_code + " " + this.origin.city;
      url = url.replace ("%origin%", origin);

      let destination = this.destination.street + " " + this.destination.house_number + " " + this.destination.postal_code + " " + this.destination.city;
      url = url.replace ("%destination%", destination);
    }
  },
  methods: {
    openGoogleMaps () {
      window.open('https://www.google.de/maps/', '_blank')
    },

    isDifferentAddress (address1, address2) {
      return address1.street !== address2.street ||
          address1.postal_code !== address2.postal_code ||
          address1.city !== address2.city ||
          address1.country !== address2.country;
    },
    slugify (string) {
      return string.replace (/\s/g, "+");
    },
    setStart (data) {
      this.start.location = {
        address: data.formatted_address,
        coordinates: data.geometry.location
      };
      this.start.loaded = true;
    },
    async initMap () {
      let tries = 0;

      let interval = setInterval (() => {
        if (typeof google !== "undefined") {
          clearInterval (interval);
          this.map.directionsService = new google.maps.DirectionsService ();
          this.map.directionsDisplay = new google.maps.DirectionsRenderer ();
          let home = new google.maps.LatLng (this.start.location.coordinates.lat, this.start.location.coordinates.lng);
          this.map.options = {
            center: home,
            zoom: 7,
            disableDefaultUI: true
          };
          this.map.map = new google.maps.Map (document.getElementById ('handoverMap'), this.map.options);
          this.map.directionsDisplay.setMap (this.map.map);
          this.map.loaded = true;
        } else {
          tries++;
          if (tries > 10) {
            clearInterval (interval);
            console.warn ('Google Maps konnte nicht geladen werden');
          }
        }
      }, 200);
    },
    calcRoute () {
      let tries = 0;

      let interval = setInterval (() => {
        if (this.map.loaded == true) {
          clearInterval (interval);
          this.showRoute();
        } else {
          tries++;
          if (tries > 10) {
            clearInterval (interval);
            console.warn ('Google Maps konnte nicht geladen werden');
          }
        }
      }, 200);

    },
    showRoute() {
      let destination = this.destination.street
          + " " + this.destination.house_number
          + ", " + this.destination.postal_code
          + " " + this.destination.city
          + ", " + this.destination.country;
      let self = this;
      let request = {
        origin: this.start.location.address,
        destination: destination,
        travelMode: 'DRIVING'
      };

      this.map.directionsService.route (request, function (result, status) {
          if (status == 'OK') {
            self.navigation.distance = result.routes[0].legs[0].distance;
            self.navigation.duration = result.routes[0].legs[0].duration;
            self.map.directionsDisplay.setDirections (result);
            self.navigation.message = "Du wärst ca. <strong>" + self.navigation.duration.text + " für die " + self.navigation.distance.text + "</strong> lange Strecke unterwegs.";
            self.navigation.show = true;
          } else {
            console.warn ('Fehler in der Routenberechnung');
          }
        });
    },
    async loadGoogleMaps () {
      let googleMaps = document.createElement('script')
      googleMaps.setAttribute('src', 'https://maps.googleapis.com/maps/api/js?key='+this.$googleMapsApi)
      googleMaps.async = true;
      document.head.appendChild(googleMaps)

      return await document
    },
    getCookie(cname){
      let name = cname + "=";
      let ca = document.cookie.split(';');
      for(let i = 0; i < ca.length; i++) {
        let c = ca[i];
        while (c.charAt(0) == ' ') {
          c = c.substring(1);
        }
        if (c.indexOf(name) == 0) {
          return c.substring(name.length, c.length);
        }
      }
      return "";
        }
  },
  mounted () {
    /*
     i'm really sorry about that workflow - feel free to improve the code
     workflow:
     - check if functional cookies are allowed by cookiefirst
     - if they are allowed the gmap script will be loaded by a function
     - after that the "normal" magic begins
     */
    this.loadGoogleMaps().then(r => {
      let street = this.origin.street;
      if (this.origin.house_number != null) {
        street = street + " " + this.origin.house_number;
      }
      axios.defaults.headers.common = {};
      axios.get("https://maps.googleapis.com/maps/api/geocode/json", {
        params: {
          address: street
              + " " + this.origin.postal_code
              + " " + this.origin.city,
          key: this.$googleMapsApi,
          region: "ch",
          country: "ch"
        }
      }).then( response => {
        let startData
        if (response.data.status === 'ZERO_RESULTS') {
          this.googleFailed = true;
        } else {
          startData = _.find (response.data.results, r => {
            let found = false;
            _.forEach (r.types, t => {
              if (t === 'premise') {
                found = true
              }
            })

            return found
          })

          if (typeof startData === 'undefined') {
            startData = response.data.results[0]
          }
        }
        return startData
      }).then(data => {
        this.setStart(data);
        this.initMap();
        this.calcRoute()
      });
    })
  }
}
</script>

<style scoped lang="scss">
#handoverMap {
  width: 100%;

  @media (min-width: 992px) {
    height: 300px;
  }

  @media (max-width: 991px) {
    height: 200px;
  }
}

i.fal {
  color: #0b97c4;
}
</style>
